export enum IDBoolean {
  false = 0,
  true = 1
}
